module.exports = __webpack_public_path__ + "static/media/colorBlack.9638ccfa.png";